import { CONTACTS } from "../data";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-forest border-t border-amber/20 pt-20 pb-10 overflow-hidden">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
        <div className="md:col-span-5">
          <span className="inline-block bg-cream px-4 py-3 rounded-sm mb-6">
            <img
              src="/logo.png"
              alt="LUSH Adventure @ Barn — Leading. Uniting. Stretching Horizons."
              className="h-14 md:h-16 w-auto"
              data-testid="footer-logo"
            />
          </span>
          <p className="text-sm text-cream/60 leading-relaxed max-w-sm">
            Powered by Learning Management Solution Trends (LMST) —
            transforming teams, building leaders, creating sustainable impact.
          </p>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs tracking-[0.25em] uppercase text-amber mb-5">Reach the Wild</p>
          <ul className="space-y-3">
            {CONTACTS.map((c) => (
              <li key={c.label}>
                <a
                  data-testid={`footer-contact-${c.label.replace(/ /g, "-")}`}
                  href={c.wa}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-cream/70 hover:text-amber transition-colors duration-300"
                >
                  {c.label}
                </a>
              </li>
            ))}
            <li className="text-sm text-cream/50">Kiriberiya, Panadura, Sri Lanka</li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs tracking-[0.25em] uppercase text-amber mb-5">Explore</p>
          <ul className="space-y-3">
            <li>
              <a data-testid="footer-link-barnhouse" href="https://barnhouse.lk" target="_blank" rel="noopener noreferrer" className="text-sm text-cream/70 hover:text-amber transition-colors duration-300">
                barnhouse.lk
              </a>
            </li>
            <li>
              <a data-testid="footer-link-lmst" href="https://lmstrends.com" target="_blank" rel="noopener noreferrer" className="text-sm text-cream/70 hover:text-amber transition-colors duration-300">
                lmstrends.com
              </a>
            </li>
            <li>
              <a data-testid="footer-link-story" href="/story" className="text-sm text-cream/70 hover:text-amber transition-colors duration-300">
                Our Story (PDF)
              </a>
            </li>
            <li>
              <a data-testid="footer-link-client-booking" href="/book" className="text-sm text-cream/70 hover:text-amber transition-colors duration-300">
                Client Booking
              </a>
            </li>
            <li>
              <a data-testid="footer-link-staff-login" href="/login" className="text-sm text-cream/70 hover:text-amber transition-colors duration-300">
                Staff Login
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/10 pt-8 flex flex-col md:flex-row justify-between gap-4">
        <p className="text-xs text-cream/40 tracking-wide">© 2026 LUSH Adventure @ Barn. All rights reserved.</p>
        <p className="text-xs text-cream/40 tracking-wide">Best Sustainable Tourism SME Project 2023 · Good Travel Seal Level One</p>
      </div>
    </div>
  </footer>
);
